import { useState, useEffect } from 'react';
import { instance } from '../../common';

const CarInfo = (props) => {
  const [carInfo, setCarInfo] = useState({
		u_car_name: '',
		u_car_number: '',
		u_app_date: '',
		u_car_color: '',
	});

  useEffect(() => {
    instance.post('/rep_car/work_id', { r_id: props.r_id }).then((res) => {
      // console.log('car info is: ', res.data[0]);
      setCarInfo(res.data[0]);
    });
  }, []);

  return (
    <section>
      <h4 className="col-12 p-0 mt-5 mb-3 font-weight-bold chRyangTitle">
        차량정보
      </h4>
      <div className="mb-3 row pb-3 border-bottom">
        {/* 차량 모델명, 차량번호, 앱 등록일, 색상 */}
        <div
          className="flex-direction-column w-100"
          style={{ border: '0', display: 'flex' }}
        >
          <label htmlFor="cname" style={{ width: '40%', marginBottom: '0' }}>
            차량 모델명
          </label>
          <input
            type="text"
            name="name"
            id="cname"
            style={{ border: '0' }}
            value={carInfo.u_car_name}
            readOnly
					/>
        </div>
        <div
          className="flex-direction-column w-100"
          style={{ border: '0', display: 'flex' }}
        >
          <label htmlFor="cnum" style={{ width: '40%', marginBottom: '0' }}>
            차량번호
          </label>
          <input
            type="text"
            name="num"
            id="cnum"
            style={{ border: '0' }}
            value={carInfo.u_car_number}
            readOnly
          />
        </div>
        <div
          className="flex-direction-column w-100"
          style={{ border: '0', display: 'flex' }}
        >
          <label htmlFor="cdate" style={{ width: '40%', marginBottom: '0' }}>
            앱 등록일
          </label>
          <input
            type="text"
            name="app-registered-date"
            id="cdate"
            style={{ border: '0' }}
            value={carInfo.u_app_date}
            readOnly
          />
        </div>
        <div
          className="flex-direction-column w-100"
          style={{ border: '0', display: 'flex' }}
        >
          <label htmlFor="ccolor" style={{ width: '40%', marginBottom: '0' }}>
            색상
          </label>
          <input
            type="text"
            name="color"
            id="ccolor"
            style={{ border: '0' }}
            value={carInfo.u_car_color}
            readOnly
          />
        </div>
      </div>
    </section>
  );
};

export default CarInfo;
